import {
  getImageBase64,
  getBackground
  , getThemePic
} from "@/views/home/slidePPT/use/methods"
import {
  pathToBase64,
  isColor
} from '@/utils'

const nodule = async (data) => {
  const node = data.node;
  const color = data.color;
  const id = Math.random().toString(36).slice(-8);
  const imgList = await getImageBase64(node.title);
  let src = "";
  if (imgList && imgList.length > 0) src = imgList[0];

  const background = await getBackground(data?.customTheme)
  return {
    id: id,
    elements: [
      {
        type: "shape",
        id: "CqHTiXseeT",
        width: 336.53207020997377,
        height: 239.5295275590551,
        left: 163.718093832021,
        top: 198.33932086614172,
        viewBox: [200, 200],
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fill: "#ffffff",
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
        outline: {
          width: 2,
          color: `${color}`,
          style: "solid",
        },
        opacity: 1,
      },
      {
        type: "text",
        id: "GCtWlbaTfd",
        width: 350.8,
        height: 33.40469160104987,
        left: 540.0036909448819,
        top: 162.4,
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fixedRatio: false,
        rotate: 0,
        content: `<p style="text-align: center;"><strong><span style="font-size: 21.09375px;"><span style="font-family: Microsoft Yahei;"><span style="color: ${color};">${node.children[0].title || ""
          }</span></span></span></strong></p>`,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333",
      },
      {
        type: "text",
        id: "rQSdQQ-f22",
        width: 425.5,
        height: 79.44922900262468,
        left: 540.0036909448819,
        top: 206.9,
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fixedRatio: false,
        rotate: 0,
        content: `<p style="text-align: left;"><span style="color: #000404;font-size: 15.625px;font-family: Microsoft Yahei;">${node.children[0].text}</span></p>`,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333",
      },
      {
        type: "text",
        id: "6FfbRNbJsk",
        width: 350.8,
        height: 33.40469160104987,
        left: 544.6997211286089,
        top: 305,
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fixedRatio: false,
        rotate: 0,
        content: `<p style="text-align: center;"><strong><span style="font-size: 21.09375px;"><span style="font-family: Microsoft Yahei;"><span style="color: ${color};">${node.children[1].title || ""
          }</span></span></span></strong></p>`,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333",
      },
      {
        type: "text",
        id: "SmCnXBVkwN",
        width: 425.5,
        height: 79.44922900262468,
        left: 544.6997211286089,
        top: 333.8,
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fixedRatio: false,
        rotate: 0,
        content: `<p style="text-align: left;"><span style="color: #000404;font-size: 15.625px;font-family: Microsoft Yahei;">${node.children[1].text}</span></p>`,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333",
      },
      {
        type: "image",
        id: "4wfrjvMGnR",
        src: src,
        width: 366.8152887139108,
        height: 239.52944553805773,
        left: 98.80807086614173,
        top: 155.72892060367454,
        fixedRatio: true,
        rotate: 0,
      },
      {
        type: "shape",
        id: "iYzB4Is880",
        width: 36.21998031496063,
        height: 36.21998031496063,
        left: 701.9799868766404,
        top: 126.1,
        viewBox: [200, 200],
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "text",
        id: "rlAlM3ofRK",
        width: 87.1763892052233,
        height: 22.09375,
        left: 701.9799868766404,
        top: 117.3,
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fixedRatio: false,
        rotate: 0,
        content:
          '<p style=""><span style="font-size: 14.84375px;"><span style="font-family: Microsoft Yahei;"><span style="color: #FFFFFF;">01</span></span></span></p>',
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333",
      },
      {
        type: "shape",
        id: "3vS-nYhRE4",
        width: 36.21998031496063,
        height: 36.21998031496063,
        left: 701.9799868766404,
        top: 268.8,
        viewBox: [200, 200],
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "text",
        id: "M0QkNetohE",
        width: 87.1763892052233,
        height: 22.09375,
        left: 701.9799868766404,
        top: 260,
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fixedRatio: false,
        rotate: 0,
        content:
          '<p style="text-align: left;"><span style="color: #FFFFFF;font-size: 14.84375px;font-family: Microsoft Yahei;">02</span></p>',
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333",
      },
      {
        type: "shape",
        id: "swnulDFMJH",
        width: 6.901820866141732,
        height: 6.901820866141732,
        left: 37.31651902887139,
        top: 29.14288057742782,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "s9z2XKlM9Z",
        width: 6.408874671916011,
        height: 6.408874671916011,
        left: 47.16609251968504,
        top: 28.90100065616798,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "5HqzAtlqbv",
        width: 6.127296587926509,
        height: 6.127296587926509,
        left: 56.52271981627297,
        top: 29.041748687664043,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "VPAPxNSIsX",
        width: 5.678969816272966,
        height: 5.678969816272966,
        left: 65.5977690288714,
        top: 29.777477034120736,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "PsfaxTjIiO",
        width: 5.38008530183727,
        height: 5.38008530183727,
        left: 74.22449146981627,
        top: 29.438484251968504,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "CM-o5rc5Lz",
        width: 6.901820866141732,
        height: 6.901820866141732,
        left: 37.31651902887139,
        top: 38.80282152230971,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "hGS2BC3JnV",
        width: 6.408874671916011,
        height: 6.408874671916011,
        left: 47.16609251968504,
        top: 38.560859580052494,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "5ebepT4pUB",
        width: 6.127296587926509,
        height: 6.127296587926509,
        left: 56.52271981627297,
        top: 38.70168963254593,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "q-6Ts9BES-",
        width: 5.678969816272966,
        height: 5.678969816272966,
        left: 65.5977690288714,
        top: 39.437417979002625,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "9orwlC-V1S",
        width: 5.38008530183727,
        height: 5.38008530183727,
        left: 74.22449146981627,
        top: 39.09842519685039,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "4lRa0bcYXp",
        width: 6.901820866141732,
        height: 6.901820866141732,
        left: 37.31651902887139,
        top: 48.4627624671916,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "ICzM5vFwkl",
        width: 6.408874671916011,
        height: 6.408874671916011,
        left: 47.16609251968504,
        top: 48.22080052493438,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "ET3TMvk8Cr",
        width: 6.127296587926509,
        height: 6.127296587926509,
        left: 56.52271981627297,
        top: 48.36154855643044,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "Y1QoU1AZ0c",
        width: 5.678969816272966,
        height: 5.678969816272966,
        left: 65.5977690288714,
        top: 49.09727690288714,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "F_oSP-8lq1",
        width: 5.38008530183727,
        height: 5.38008530183727,
        left: 74.22449146981627,
        top: 48.758284120734906,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "Aq-yS1Yrj2",
        width: 6.901820866141732,
        height: 6.901820866141732,
        left: 37.31651902887139,
        top: 58.122621391076116,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "kVz-LSjOg_",
        width: 6.408874671916011,
        height: 6.408874671916011,
        left: 47.16609251968504,
        top: 57.88074146981627,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "J8aTY7Auag",
        width: 6.127296587926509,
        height: 6.127296587926509,
        left: 56.52271981627297,
        top: 58.02148950131234,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "u0_d6hJehJ",
        width: 5.678969816272966,
        height: 5.678969816272966,
        left: 65.5977690288714,
        top: 58.75721784776903,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "q0L7baliRE",
        width: 5.38008530183727,
        height: 5.38008530183727,
        left: 74.22449146981627,
        top: 58.418225065616795,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
      },
      {
        type: "text",
        id: "e1VdSiVMNz",
        width: 820.500997375328,
        height: 57.5,
        left: 89.74950131233598,
        top: 29.14288713910761,
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fixedRatio: false,
        rotate: 0,
        content: `<p style=""><strong><span style="font-size: 25px;"><span style="font-family: Microsoft Yahei;">${node.title || ""
          }</span></span></strong></p>`,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333",
      },
    ],
    background,
  };
};

export default nodule;
